import bindSmoothScroll from './_ceh-anchorlinklist-main.js'

$(function() {
    bindSmoothScroll(document.querySelectorAll('.cmp-toc__content a[href^="#"]'));
    bindSmoothScroll(document.querySelectorAll('.js-ceh-anchor-link a[href^="#"]'));
    bindSmoothScroll(document.querySelectorAll('.button a[href^="#"]'));
    bindSmoothScroll(document.querySelectorAll('.ceh-button a[href^="#"]'));
});
